import React, { Component } from "react";

import { getSettings } from "features/new/footer/requests/get-settings";

import FooterView from "features/new/footer/component/view";

class Footer extends Component {
  constructor(props) {
    super(props);

    this.state = { contactEmail: "inquiries@parlor.social" };
  }

  componentDidMount() {
    getSettings().then((response) =>
      this.setState({
        contactEmail: response.data.data.email_contact_from_website,
      })
    );
  }

  render() {
    const { contactEmail } = this.state;

    return <FooterView contactEmail={contactEmail} />;
  }
}

export default Footer;
